import axios from 'axios';

/**
 * Shared axios instance for the public web API. Every page folder owns its own
 * `api.ts` with named endpoint functions that call `apiClient.get/post/put/...`.
 * Status-code-specific error mapping ('not_found', 'failed', etc.) stays close
 * to each endpoint via per-function .catch() chains — mirroring the mobile
 * pattern at `mobile/src/services/api.ts`.
 */
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL ?? 'http://localhost:4000/api',
  headers: { 'Content-Type': 'application/json' },
});

export default apiClient;
